var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#4A2FBD"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M0 0.5V63.5H63V0.5H0ZM34.2844 49.6344C34.2844 55.7656 30.6844 58.5641 25.4391 58.5641C20.7 58.5641 17.9578 56.1172 16.5516 53.15L21.375 50.2391C22.3031 51.8844 23.1469 53.2766 25.1859 53.2766C27.1266 53.2766 28.3641 52.5172 28.3641 49.55V29.4266H34.2844V49.6344ZM48.2906 58.5641C42.7922 58.5641 39.2344 55.9484 37.5047 52.5172L42.3281 49.7328C43.5938 51.8 45.2531 53.3328 48.1641 53.3328C50.6109 53.3328 52.1859 52.1094 52.1859 50.4078C52.1859 48.3828 50.5828 47.6656 47.8687 46.4703L46.3922 45.8375C42.1172 44.0234 39.2906 41.7313 39.2906 36.9078C39.2906 32.4641 42.6797 29.0891 47.9531 29.0891C51.7219 29.0891 54.4219 30.3969 56.3625 33.8281L51.75 36.7812C50.7375 34.9672 49.6406 34.25 47.9391 34.25C46.2094 34.25 45.1125 35.3469 45.1125 36.7812C45.1125 38.5531 46.2094 39.2703 48.7547 40.3813L50.2313 41.0141C55.2656 43.1656 58.0922 45.3734 58.0922 50.3234C58.0922 55.6391 53.9016 58.5641 48.2906 58.5641Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.e6ebc4334c6277d99fd13521ee970d7e.svg";
export { ForwardRef as ReactComponent };